export const DAF_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:token-exchange';
export const DAF_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
export const DAF_SUBJECT_TOKEN_TYPE = 'nab:oauth:token-type:client_id';
export const DAF_TOKEN_RETRY_COUNT_MAX: number = 3;
